/*
 * Mirelia — scroll reveal.
 *
 * Elements carrying [data-mirelia-reveal] fade up once, the first time they
 * enter the viewport. Content is visible without this script; the hidden start
 * state is only applied after the script confirms it can run.
 */

const REVEAL_SELECTOR = '[data-mirelia-reveal]';
const READY_CLASS = 'mirelia-reveal-ready';
const REVEALED_CLASS = 'is-revealed';
const ROOT_MARGIN = '0px 0px -12% 0px';

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function reveal(entries, observer) {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    entry.target.classList.add(REVEALED_CLASS);
    observer.unobserve(entry.target);
  });
}

function observeAll(elements) {
  const observer = new IntersectionObserver(reveal, {
    rootMargin: ROOT_MARGIN,
    threshold: 0.06,
  });
  elements.forEach((element) => observer.observe(element));
}

function startRevealing() {
  const elements = document.querySelectorAll(REVEAL_SELECTOR);
  if (elements.length === 0) return;

  document.documentElement.classList.add(READY_CLASS);
  observeAll(elements);
}

function init() {
  if (!('IntersectionObserver' in window) || prefersReducedMotion()) return;
  startRevealing();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
